// Chargement des dictionnaires exportés par `bin/rails frontend:i18n`, côté
// client : un chunk par langue, chargé une fois (empreinte dans le nom de
// fichier, donc mis en cache durablement). Le SSR, lui, embarque toutes les
// langues (ssr/ssr.tsx).
import { setTranslations } from '@/lib/i18n'

type Messages = Record<string, unknown>

const locales = import.meta.glob<Messages>('../locales/*.json', { import: 'default' })
const pathFor = (locale: string) => `../locales/${locale}.json`

export async function loadTranslations(locale: string): Promise<void> {
  const loader = locales[pathFor(locale)] ?? locales[pathFor('en')]
  setTranslations(locale, await loader())
}
